import { translate as t } from '@thoughtspot/i18n';
const MAX_FILE_SIZE_BYTES = 2 * 1024 * 1024;
export function validateFile(file) {
    if (!file.name.toLowerCase().endsWith('.csv')) {
        return {
            isValid: false,
            error: t('adminSection.manualTranslation.fileTypeError'),
        };
    }
    if (file.size > MAX_FILE_SIZE_BYTES) {
        return {
            isValid: false,
            error: t('adminSection.manualTranslation.fileSizeError'),
        };
    }
    if (file.size === 0) {
        return {
            isValid: false,
            error: t('adminSection.manualTranslation.fileEmptyError'),
        };
    }
    return { isValid: true };
}
//# sourceMappingURL=csv-validation.util.js.map